module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Modpack step 2.791e763a.webp";